import { useContext } from 'react';
import { FileConfigurationContext } from './FileConfigurationContext';

export default function useFileConfigurations() {
  return useContext(FileConfigurationContext);
}
